import React, { useState, useEffect, useRef } from "react";
import SelectInput from "./SelectInput";
import months from "./../../src/concerns/months";

const DatePicker = ({ stepIsValid, model }) => {
  const today = new Date();
  const thisYear = today.getFullYear();

  const [year, setYear] = useState();
  const [month, setMonth] = useState();
  const [day, setDay] = useState();

  const yearRef = useRef();
  const monthRef = useRef();
  const dayRef = useRef();

  const years = [
    {
      label: thisYear,
      value: thisYear,
    },
    {
      label: thisYear - 1,
      value: thisYear - 1,
    },
    {
      label: thisYear - 2,
      value: thisYear - 2,
    },
    {
      label: thisYear - 3,
      value: thisYear - 3,
    },
    {
      label: thisYear - 4,
      value: thisYear - 4,
    },
    {
      label: thisYear - 5,
      value: thisYear - 5,
    },
  ];

  useEffect(() => {
    const isValid = () => {
      if ((year, month, day)) {
        stepIsValid(true);
      } else {
        stepIsValid(false);
      }
    };

    if (
      yearRef.current != year ||
      monthRef.current != month ||
      dayRef.current != day
    ) {
      yearRef.current = year;
      monthRef.current = month;
      dayRef.current = day;
      isValid();
    }
  });

  const numberOfDays = new Date(year, month, 0).getDate();
  const days = Array.from({ length: numberOfDays }, (v, i) => {
    return {
      label: i + 1,
      value: i + 1,
    };
  });

  return (
    <div>
      <div>
        <SelectInput
          model={model}
          label={"année"}
          options={years}
          setValue={setYear}
          field={"date(1i)"}
        />
      </div>
      <div className={`${year ? "block" : "hidden"} my-3`}>
        <SelectInput
          model={model}
          label={"mois"}
          options={months}
          setValue={setMonth}
          field={"date(2i)"}
        />
      </div>
      <div className={`${month ? "block" : "hidden"} my-3`}>
        <SelectInput
          model={model}
          label={"jour"}
          options={days}
          setValue={setDay}
          field={"date(3i)"}
        />
      </div>
    </div>
  );
};

export default DatePicker;
